import { publicV2 } from '@/plugins/axios'
import Service from '@/services/service'

/******************************************************************************
 *  Public
 *****************************************************************************/

/**
 * @type {Public}
 */
export default class Public extends Service {
    createPublic(url, data) {
        return publicV2.post(url, data)
            .then(response => response)
            .catch(error => error)
    }
    getPublic(url) {
        return publicV2.get(url)
            .then(response => response)
            .catch(error => error)
    }
}